import { Button, Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { syncVersionEffect } from 'app/store/Releases/effects';
import { useAppDispatch, useAppSelector } from 'app/store';
import { useState } from 'react';
import { getRelease, getReleaseVersion } from 'app/store/Releases/selectors';
import { apiUrls } from 'app/api.config';
import { useReleaseCallbackUrl } from './useReleaseCallbackUrl';
import { VersionSyncDialog } from '../VersionSyncDialog';

interface ReleaseActionsProps {
  tab: 'details' | 'contributions' | 'lyrics' | 'splits';
  syncState: boolean;
  leftSocket?: React.ReactNode;
}

export const ReleaseActions = ({
  tab,
  syncState,
  leftSocket,
}: ReleaseActionsProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const release = useAppSelector(getRelease);
  const releaseVersion = useAppSelector(getReleaseVersion);

  const [isOpen, setIsOpen] = useState(false);
  const url = useReleaseCallbackUrl(tab);

  const handleSync = () => {
    const versionGuid = releaseVersion?.metadata.guid;
    dispatch(
      syncVersionEffect({
        link: versionGuid
          ? {
              href: apiUrls.syncRelease
                .replace(':releaseGuid', releaseVersion.metadata.releaseGuid)
                .replace(':versionGuid', versionGuid),
              method: 'POST',
            }
          : undefined,
        songGuid: releaseVersion?.song.songGuid as string,
        versionGuid: versionGuid as string,
        releaseType: release?.type,
      })
    );
    setIsOpen(false);
  };

  return (
    <>
      <Flex position="absolute" top={-16} right={4} gap={4}>
        {leftSocket}
        <Button
          variant="secondary"
          size="md"
          isDisabled={false}
          onClick={() => navigate(url)}
        >
          Go to Song
        </Button>
        {setIsOpen && (
          <Button
            variant="secondary"
            size="md"
            isDisabled={syncState}
            onClick={() => setIsOpen(true)}
          >
            Sync
          </Button>
        )}
      </Flex>
      <VersionSyncDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        handleAction={handleSync}
      />
    </>
  );
};
